export default __webpack_public_path__ + "static/media/kitchen3-afterA-480w.a4d45985.png";